// Write your code here
import {AiFillClockCircle} from 'react-icons/ai'

const CourseTimelineCard = props => {
  const {tagsList, courseTitle, description, duration} = props
  const renderTagList = () => (
    <ul>
      {tagsList.map(tag => (
        <li key={tag.id}>
          <p>{tag.name}</p>
        </li>
      ))}
    </ul>
  )
  return (
    <div>
      <div>
        <h1>{courseTitle}</h1>
        <div>
          <AiFillClockCircle />
          <p>{duration}</p>
        </div>
      </div>
      <p>{description}</p>
      {renderTagList()}
    </div>
  )
}

export default CourseTimelineCard
